module.exports = __webpack_public_path__ + "static/img/egg_b_16.2708382.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_16.png
// module id = oLx7
// module chunks = 1